import { gql, useQuery } from '@apollo/client'
import { useAuth0 } from '@auth0/auth0-react'
import { useContext, useEffect } from 'react'
import { Navbar } from 'shared-components'
import { getCurrentEnvConfig } from '../../../config'
import { AppContext } from '../../providers/AppContext/AppContext'
import LinkComponent from '../LinkComponent/LinkComponent'
import Register from '../Register/Register'

export const GET_PROFILE_DETAILS = gql(`
    query getProfile {
        me {
            handle
            id
        }
    }
`)

const NavBarWrapper = () => {
  const { playerDetails, setPlayerDetails, eventDetails } =
    useContext(AppContext)
  const {
    isAuthenticated,
    isLoading: isAuthLoading,
    loginWithRedirect,
    logout,
  } = useAuth0()

  const {
    data: userProfileResponse,
    error: userProfileError,
    loading: userProfileLoading,
  } = useQuery(GET_PROFILE_DETAILS, {
    skip: !isAuthenticated || !!playerDetails.handle,
  })

  const profileHandle =
    playerDetails.handle || userProfileResponse?.me?.handle || null

  const isHandleLoading =
    isAuthLoading || (isAuthenticated && !profileHandle && userProfileLoading)

  useEffect(() => {
    if (userProfileResponse) {
      setPlayerDetails({
        ...playerDetails,
        handle: userProfileResponse?.me?.handle ?? '',
      })
    }
  }, [userProfileResponse, userProfileError])

  return (
    <Navbar
      LinkComponent={LinkComponent}
      isAuthenticated={isAuthenticated}
      logIn={() => {
        loginWithRedirect()
      }}
      signOut={() => {
        logout({
          logoutParams: {
            returnTo:
              typeof window !== 'undefined' ? `${window.location.origin}` : '',
          },
        })
      }}
      handle={profileHandle ? `@${profileHandle}` : null}
      isHandleLoading={isHandleLoading}
      RegisterComponent={
        <Register buttonVariant="text" trackingLocation="navbar" />
      }
      hasActiveEvent={
        !!getCurrentEnvConfig().activeEventSlug &&
        eventDetails.status !== 'FINISHED'
      }
      pennyLaneBaseUrl={getCurrentEnvConfig().pennyLaneBaseUrl}
    />
  )
}

export default NavBarWrapper
